/* eslint-disable @typescript-eslint/ban-types */
import React, { useMemo } from 'react';
import { Row, ColumnInstance } from 'react-table';

import { formatNumberCompact } from '@trqk/utils';

interface SumFooterProps<D extends object> {
    column: ColumnInstance<D>;
    flatRows: Row<D>[];
}

/**
 * Sums and displays the total of all cell values for a given column. Cell values must be `numbers
 * for this footer to work.
 * @param props - {@link SumFooterProps}
 */
export function SumFooter<D extends object>({
    column,
    flatRows,
}: SumFooterProps<D>): JSX.Element {
    const sum = useMemo(
        () =>
            flatRows.reduce((acc, row) => {
                if (row.depth === 0 && row.canExpand) {
                    return (row?.values?.[column.id] ?? 0) + acc;
                }

                return acc;
            }, 0),
        [flatRows],
    );

    return <>{formatNumberCompact(sum)}</>;
}
